import axios from 'axios';

const API_URL = '/api/v1';

export const getEvents = async (page = 1, query = '') => {
  const params = { page, ...(query ? { q: query } : {}) };
  const response = await axios.get(`${API_URL}/events`, { params });
  return response.data;
};

export const getEvent = async (id) => {
  const response = await axios.get(`${API_URL}/events/${id}`);
  return response.data;
};

export const createEvent = async (eventData) => {
  const token = localStorage.getItem('auth_token');
  const response = await axios.post(`${API_URL}/events`, { event: eventData }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const updateEvent = async (id, eventData) => {
  const token = localStorage.getItem('auth_token');
  const response = await axios.patch(`${API_URL}/events/${id}`, { event: eventData }, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const deleteEvent = async (id) => {
  const token = localStorage.getItem('auth_token');
  await axios.delete(`${API_URL}/events/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
